"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  buildTime: "2024-11-22T21:37:03Z",
  commit: "112e11763714ff32a6e8446a02d60de1460e7a09",
  npmInfo: {
    'solid-panes': '3.6.1',
    npm: '8.19.4',
    node: '20.18.0',
    acorn: '8.12.1',
    ada: '2.9.0',
    ares: '1.33.1',
    base64: '0.5.2',
    brotli: '1.1.0',
    cjs_module_lexer: '1.4.1',
    cldr: '45.0',
    icu: '75.1',
    llhttp: '8.1.2',
    modules: '115',
    napi: '9',
    nghttp2: '1.61.0',
    nghttp3: '0.7.0',
    ngtcp2: '1.1.0',
    openssl: '3.0.13+quic',
    simdutf: '5.5.0',
    tz: '2024a',
    undici: '6.19.8',
    unicode: '15.1',
    uv: '1.46.0',
    uvwasi: '0.0.21',
    v8: '11.3.244.8-node.23',
    zlib: '1.3.0.1-motley-71660e1'
  }
};
//# sourceMappingURL=versionInfo.js.map